import { Splide } from "@splidejs/splide";

const carousel = () => {
  const targetElms = document.getElementsByClassName('js-recommendSlider');
  if(targetElms.length === 0) return;
  
  for(const targetElm of targetElms) {
    const speed = 1500;
    let options = {
      type: "loop",
      speed: speed,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoWidth: true,
      autoplay: true,
      updateOnMove: true,
      gap: '4rem',
      arrows: false,
      pagination: false,
      reduceMotion: {
        speed: speed,
      },
      breakpoints: {
        992: {
          drag: true,
          gap: "2rem",
        }
      }
    }

    const slider = new Splide(targetElm, options);
    const bar = slider.root.querySelector(".my-carousel-progress-bar");

    // バーを現在位置に移動させる
    slider.on("mounted move", function () {
      const end = slider.Components.Controller.getEnd() + 1;
      const rate = slider.index / end; // 0から始まる位置の割合
      const barWidth = 100 / end; // バーの幅（全体を均等分割）
      
      bar.style.width = barWidth + "%";
      bar.style.transform = `translateX(${rate * 100 * end}%)`;
      bar.style.transition = "transform 0.3s ease";
    });
    
    slider.mount();
  }
}

const init = () => {
  carousel();
}

export default init;